// extracted by mini-css-extract-plugin
export default {"pushable":"MainButton_pushable__CEZrl","front":"MainButton_front__5kzz3"};